import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { CommentaireDTO } from '../model/commentaire-dto';

@Injectable({
    providedIn: 'root'
  })
  export class CommentaireService{

    constructor(private _restClientService : RestClientService) 
    {}

    getCommentaires(requestId) 
    {
        return this._restClientService.load<CommentaireDTO[]>('commentaire/find-by-request/'+requestId);
    }
    
}      

    